import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { config } from "../../config";
import { moduleSettings } from "../../stores/module-settings.store";

const GolLogo = styled.div`
  a {
    display: flex;
    align-items: center;
    font-size: 0.8rem;
    margin-left: 24px;
    text-decoration: none;

    @media screen and (max-width: 780px) {
      font-size: 0.7rem;
    }
  }
  a:link,
  a:link,
  a:visited,
  a:active {
    color: #333333 !important;
  }
`;

const Img = styled.img`
  width: 50px;
  margin-left: 8px;
`;

const AppLogo = () => {
  const { i18n } = useTranslation();
  const poweredByLogo = moduleSettings.poweredByLogo;
  const poweredByText = moduleSettings.getPoweredByText(i18n.language);
  const poweredByUrl = moduleSettings.poweredByUrl;

  return (
    <GolLogo data-test="logo-gol">
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={poweredByUrl.toString()}
      >
        <span>{poweredByText}</span>
        <Img src={config.baseImageUrl + poweredByLogo} alt="" />
      </a>
    </GolLogo>
  );
};
export const Logo = memo(AppLogo);
